<footer class="d-none d-sm-block" id="footer">
    <div class="footer-row">
        <div class="logo-footer">
            <a href="https://www.b-trust.org/" target="_blank">
                <img src="../assets/images/logos/btrust.svg" alt="B-trust Borica logo">
            </a>
        </div>
        <div class="logo-footer">
            <a href="https://www.b-trust.bg/electronic-signatures/products/cloud-certificates/cloud-standart"
                target="_blank">
                <img id="bLogo" src="../assets/images/logos/btm.svg" alt="B-trust Mobile logo" class="btm-logo">
            </a>
        </div>
        <div class="logo-footer">
            <a href="https://www.borica.bg/products-and-services/infopay" target="_blank">
                <img src="../assets/images/logos/info-pay.svg" alt="Info Pay Borica logo" class="infoplay-logo">
            </a>
        </div>
        <div class="logo-footer">
            <a href="http://www.efaktura.bg/bg" target="_blank">
                <img src="../assets/images/logos/efaktura.svg" alt="E-faktura Borica logo">
            </a>
        </div>
    </div>
    <div class="row">
        <a class="col-12 signature" href="https://www.borica.bg/" target="_blank"> &#169; {{year}} - {{'signature' |
            translate}}&nbsp; </a>
        <br class="d-block d-sm-none">
    </div>
</footer>